import { americasRegionFeatures } from './americasRegion';
import { europeRegionFeatures } from './europeRegion';

export const allRegionsFeaturesList = [
    ...americasRegionFeatures,
    ...europeRegionFeatures,
];
